(function () {
  "use strict";

  angular
    .module("financialDataAccordion.components", [])
    .component("financialDataAccordion", {
      templateUrl: "ng/components/financialDataAccordion/financialDataAccordion.view.html",
      bindings: {
        amount: "<",
        financialData: "=",
        financialDataAccordionOk: "&?",
        financialDataAccordionNotOk: "&?"
      },
      controllerAs: "financialDataAccordionCtrl",
      controller: FinancialDataAccordionController
    });

  function FinancialDataAccordionController(
    FinancialData
  ) {
    var self = this;

    self.financialDataExt = {
      priceListInputData: [{
          item: "Listino 1"
        },
        {
          item: "Listino 2"
        },
        {
          item: "Listino 3"
        }
      ],
      priceListPicks: [],
      durationPriceListInputData: [{
        item: "Importo 1"
      }, {
        item: "Importo 2"
      }, {
        item: "Importo 3"
      }],
      durationPriceListPicks: [],
      feePeriodicityInputData: [{
          item: "Durata 1"
        },
        {
          item: "Durata 2"
        },
        {
          item: "Durata 3"
        }
      ],
      feePeriodicityPicks: [],
      rentPeriodInputData: [{
          item: "Periodicità 1"
        },
        {
          item: "Periodicità 2"
        },
        {
          item: "Periodicità 3"
        }
      ],
      rentPeriodPicks: [],
      firstDueInputData: [{
          item: "Scadenza 1"
        },
        {
          item: "Scadenza 2"
        },
        {
          item: "Scadenza 3"
        }
      ],
      firstDuePicks: [],
      advanceTypeInputData: [{
          item: "Anticipo 1"
        },
        {
          item: "Anticipo 2"
        },
        {
          item: "Anticipo 3"
        }
      ],
      advanceTypePicks: [],
      expensesInputData: [{
          item: "Spese 1"
        },
        {
          item: "Spese 2"
        },
        {
          item: "Spese 3"
        }
      ],
      expensesPicks: [],
      typeRateInputData: [{
          item: "Tasso 1"
        },
        {
          item: "Tasso 2"
        },
        {
          item: "Tasso 3"
        }
      ],
      typeRatePicks: [],
      calculationModeInputData: [{
          item: "Modalità 1"
        },
        {
          item: "Modalità 2"
        },
        {
          item: "Modalità 3"
        }
      ],
      calculationModePicks: [],
      defermentPaymentInputData: [{
          item: "Dilazione 1"
        },
        {
          item: "Dilazione 2"
        },
        {
          item: "Dilazione 3"
        }
      ],
      defermentPaymentPicks: [],
      prelocationChargesInputData: [{
          item: "Prelocazione 1"
        },
        {
          item: "Prelocazione 2"
        },
        {
          item: "Prelocazione 3"
        }
      ],
      prelocationChargesPicks: []
    };

    // var transform = function () {
    //   self.financialDataExt =
    //     Object.keys(self.financialDataExt)
    //     .forEach(function (arrayName) {

    //       if (self.financialDataExt[arrayName].length == 0) {
    //         self.financialDataExt[arrayName] = [{
    //           item: "Stub"
    //         }];
    //       } else {
    //         self.financialDataExt[arrayName] = self.financialDataExt[arrayName]
    //           .map(function (elem) {
    //             return {
    //               item: elem || "stub"
    //             }
    //           })

    //       }
    //     })

    // }

    self.$onInit = function () {
      self.financialData = self.financialData || null;

      //transform();
    };

    self.onChange = function (s) {
      var data = Object.assign({}, self.financialData);
      if (data.priceList &&
        //data.durationPriceList &&
        data.feePeriodicity &&
        data.rentPeriod &&
        data.numberOfRates &&
        data.firstDue &&
        data.advanceType &&
        data.advanceValue &&
        data.advanceValuePercentage &&
        data.ransomValue &&
        data.ransomValuePercentage &&
        data.expenses &&
        data.typeRate &&
        data.calculationMode &&
        data.baseRate &&
        data.trasfRate &&
        data.dateRate &&
        data.commissions &&
        data.commissionsPercentage &&
        data.approvedExpenses &&
        data.defermentPayment &&
        data.defermentPaymentInput &&
        data.prelocationCharges &&
        data.prelocationChargesInput &&
        data.grossRate
        //data.quoteNotes
      ) {
        self.financialDataAccordionOk();
      } else {
        self.financialDataAccordionNotOk();
      }
    };

    self.onDerivedChange = function (field) {
      field.derived = !field.derived;
      self.onChange('derived');
    };

    self.onVariableChange = function (field) {
      field.variableRate = !field.variableRate;
      self.onChange('variableRate');
    };

    self.onApprovedExpensesCheckedChange = function (field) {
      field.approvedExpensesChecked = !field.approvedExpensesChecked;
      self.onChange('approvedExpensesChecked');
    };

    self.onAssuranceChange = function () {
      //self.onChange('assurance');
    }

    self.onAssuranceOk = function () {
      $scope.assuranceIsEnabled = true;
      self.onChange('onAssuranceOk');
    };

    self.onAssuranceNotOk = function () {
      $scope.assuranceIsEnabled = false;
      self.onChange('onAssuranceNotOk');
    };

    self.riepilogoSpese = {};
    (self.riepilogoSpese.tooltip =
      '<div class="row"><div class="col-xs-12 tooltip-title"><p>' +
      850.91 +
      '</p></div></div><div class="row"><div class="col-xs-9"><p>' +
      400),
    77 + '</p></div><div class="col-xs-3"><p>' + 56,
      78 + '</p></div></div><div class="row"><div class="col-xs-9"><p>' + 55,
      14 + '</p></div><div class="col-xs-3"><p>' + 11,
      23 +
      '</p></div></div><hr class="m-t-5 m-b-5"><div class="row"><div class="col-xs-9">' +
      850,
      91 + '</div><div class="col-xs-3">' + 850,
      91 + "</div></div>";
  }
})();